<span
  [class]="`d-inline-block position-relative ${icon() ?? ''} ${color() ?? ''} ${size()}`"
  [attr.aria-label]="altText() ? (altText() | translate) : null"
  [attr.aria-hidden]="!altText()"
  [attr.role]="altText() ? 'img' : 'presentation'"
>
  @if (stackedIcon()) {
    <i
      aria-hidden="true"
      [class]="`position-absolute start-0 ${stackedIcon()} ${stackedColor() ?? ''}`"
    ></i>
  }
</span>
